import { render, staticRenderFns } from "./PersonnalCard.vue?vue&type=template&id=27f0a65c&scoped=true&"
import script from "./PersonnalCard.vue?vue&type=script&lang=js&"
export * from "./PersonnalCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonnalCard.vue?vue&type=style&index=0&id=27f0a65c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0a65c",
  null
  
)

export default component.exports